<template>
    <div>       
        <b-tabs v-model="tabIndex">
            <b-tab active>
                <template slot="title">
                    <h6 class="colorEmision">GR. Remitente</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 0">
                    <guia-remision-emision @tabindex="changeTab"></guia-remision-emision>
                </template>
            </b-tab>
            <b-tab title="Emitidas">
                <template v-if="tabIndex == 1">
                    <guia-remision-consulta @tabindex="changeTab"></guia-remision-consulta>
                </template>
            </b-tab>
            <template v-if="mostrarOcultarGuia == 1">
            <b-tab>
                <template slot="title">
                    <h6 class="colorEmision">GR. Transportista</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 2">
                   <guia-remision-transportista-emision @tabindex="changeTab"></guia-remision-transportista-emision>
                </template>
            </b-tab>
            <b-tab title="Emitidas">
                <template v-if="tabIndex == 3">
                    <guia-remision-transportista-consulta></guia-remision-transportista-consulta>
                </template>
            </b-tab>
            </template>
        </b-tabs>
    </div>
</template>

<script>
import GuiaRemisionEmision from '@/components/guiaremision/GuiaRemisionEmision'
import GuiaRemisionConsulta from '@/components/guiaremision/GuiaRemisionConsulta'
import GuiaRemisionTransportistaEmision from '@/components/guiaremisiontransportista/GuiaRemisionTransportistaEmision'
import GuiaRemisionTransportistaConsulta from '@/components/guiaremisiontransportista/GuiaRemisionTransportistaConsulta'
export default {
    name: 'GuiaRemision',
    components: {
        GuiaRemisionEmision,
        GuiaRemisionConsulta,
        GuiaRemisionTransportistaEmision,
        GuiaRemisionTransportistaConsulta
    },
    data: () => {
        return {
            tabIndex: 0,
            mostrarOcultarGuia: ''
        }
    },
    mounted(){
        this.ocultarGuiaTransportista();
    },
    methods: {
        changeTab: function (value){
            this.tabIndex = value
        },
        ocultarGuiaTransportista(){
            this.mostrarOcultarGuia = this.$store.getters.guiaTransportista
        }
    }
}
</script>

